// Data Perencanaan & Master Dapil Resmi dari Dokumen PPT
// Sumber: Target_Kursi_Kab_Sukabumi_2029.pptx (Slide 1 - 4)

export const MASTER_DAPIL_DATA = [
  {
    dapil: 'Dapil 1',
    nama: 'Dapil 1',
    kecamatan_count: 6,
    desa_count: 58,
    rw_count: 492,
    dpt_2024: 290613,
    baseline_2024: 15719,
    target_suara_2029: 21419,
    target_kursi_2029: 1,
    gap_suara: 5700,
    kategori: 'Perjuangan',
    is_tambah: false,
    ambang_tambahan: null,
    target_desa_avg: 369.3,
    target_rw_avg: 40.6,
    gap_rw_avg: 10.8,
    strategi: 'Fokus amankan 1 kursi definitif. Optimalkan basis Cisolok, Palabuhanratu, dan Warungkiara serta perkuat jaringan simpul RW.',
    kecamatan: [
      { nama: 'Cisolok', baseline_2024: 4756, pct: '12,7%', rank: 2, target_2029: 5956, gap: 1200 },
      { nama: 'Cikakak', baseline_2024: 2308, pct: '10,4%', rank: 6, target_2029: 3208, gap: 900 },
      { nama: 'Warungkiara', baseline_2024: 2367, pct: '7,5%', rank: 4, target_2029: 3567, gap: 1200 },
      { nama: 'Palabuhanratu', baseline_2024: 3661, pct: '6,4%', rank: 8, target_2029: 4661, gap: 1000 },
      { nama: 'Bantargadung', baseline_2024: 1192, pct: '6,2%', rank: 7, target_2029: 1892, gap: 700 },
      { nama: 'Simpenan', baseline_2024: 1435, pct: '4,8%', rank: 8, target_2029: 2135, gap: 700 },
    ]
  },
  {
    dapil: 'Dapil 2',
    nama: 'Dapil 2',
    kecamatan_count: 8,
    desa_count: 60,
    rw_count: 499,
    dpt_2024: 375634,
    baseline_2024: 23392,
    target_suara_2029: 33492,
    target_kursi_2029: 1,
    gap_suara: 10100,
    kategori: 'Perjuangan',
    is_tambah: false,
    ambang_tambahan: null,
    target_desa_avg: 567.7,
    target_rw_avg: 74.4,
    gap_rw_avg: 22.4,
    strategi: 'Kawal dan amankan 1 kursi definitif. Fokus penguatan simpul RW di Cicurug, Cidahu, dan Parungkuda.',
    kecamatan: [
      { nama: 'Cidahu', baseline_2024: 4540, pct: '11,6%', rank: 3, target_2029: 5640, gap: 1100 },
      { nama: 'Cicurug', baseline_2024: 6663, pct: '8,9%', rank: 5, target_2029: 8863, gap: 2200 },
      { nama: 'Parungkuda', baseline_2024: 3707, pct: '8,7%', rank: 4, target_2029: 5307, gap: 1600 },
      { nama: 'Kalapanunggal', baseline_2024: 2500, pct: '8,6%', rank: 6, target_2029: 3500, gap: 1000 },
      { nama: 'Kabandungan', baseline_2024: 1606, pct: '7,3%', rank: 7, target_2029: 2606, gap: 1000 },
      { nama: 'Bojonggenteng', baseline_2024: 1566, pct: '7,1%', rank: 5, target_2029: 2566, gap: 1000 },
      { nama: 'Parakansalak', baseline_2024: 1663, pct: '6,6%', rank: 5, target_2029: 2863, gap: 1200 },
      { nama: 'Ciambar', baseline_2024: 1147, pct: '4,7%', rank: 8, target_2029: 2147, gap: 1000 },
    ]
  },
  {
    dapil: 'Dapil 3',
    nama: 'Dapil 3',
    kecamatan_count: 6,
    desa_count: 59,
    rw_count: 587,
    dpt_2024: 355656,
    baseline_2024: 29914,
    target_suara_2029: 58764,
    target_kursi_2029: 2,
    gap_suara: 28850,
    kategori: 'Menantang',
    is_tambah: true,
    ambang_tambahan: 50938,
    target_desa_avg: 996.0,
    target_rw_avg: 100.8,
    gap_rw_avg: 49.5,
    strategi: 'Peluang besar raih 2 kursi (ambang tambahan 50.938 suara). Akselerasi penetrasi di Cibadak, Nagrak, Cikembar, dan Cicantayan.',
    kecamatan: [
      { nama: 'Cibadak', baseline_2024: 10774, pct: '17,3%', rank: 1, target_2029: 15674, gap: 4900 },
      { nama: 'Cicantayan', baseline_2024: 4147, pct: '12,5%', rank: 4, target_2029: 7847, gap: 3700 },
      { nama: 'Cikidang', baseline_2024: 3840, pct: '11,9%', rank: 5, target_2029: 9290, gap: 5450 },
      { nama: 'Nagrak', baseline_2024: 5319, pct: '10,8%', rank: 4, target_2029: 10819, gap: 5500 },
      { nama: 'Caringin', baseline_2024: 2111, pct: '7,9%', rank: 7, target_2029: 5661, gap: 3550 },
      { nama: 'Cikembar', baseline_2024: 3723, pct: '7,7%', rank: 6, target_2029: 9473, gap: 5750 },
    ]
  },
  {
    dapil: 'Dapil 4',
    nama: 'Dapil 4',
    kecamatan_count: 9,
    desa_count: 67,
    rw_count: 573,
    dpt_2024: 400636,
    baseline_2024: 52788,
    target_suara_2029: 85338,
    target_kursi_2029: 3,
    gap_suara: 32550,
    kategori: 'Potensial',
    is_tambah: true,
    ambang_tambahan: 78106,
    target_desa_avg: 1273.7,
    target_rw_avg: 126.4,
    gap_rw_avg: 48.2,
    strategi: 'Basis terkuat PKS. Maksimalkan 3 kursi (ambang tambahan 78.106 suara). Perluas dominasi di Cisaat, Sukaraja, Kadudampit, dan Kebonpedes.',
    kecamatan: [
      { nama: 'Kebonpedes', baseline_2024: 6083, pct: '35,3%', rank: 1, target_2029: 8583, gap: 2500 },
      { nama: 'Kadudampit', baseline_2024: 7391, pct: '23,1%', rank: 1, target_2029: 11191, gap: 3800 },
      { nama: 'Gegerbitung', baseline_2024: 4049, pct: '18,8%', rank: 1, target_2029: 7499, gap: 3450 },
      { nama: 'Cisaat', baseline_2024: 12964, pct: '18,6%', rank: 2, target_2029: 18814, gap: 5850 },
      { nama: 'Cireunghas', baseline_2024: 2986, pct: '17,1%', rank: 2, target_2029: 5236, gap: 2250 },
      { nama: 'Sukaraja', baseline_2024: 7496, pct: '16,7%', rank: 3, target_2029: 12396, gap: 4900 },
      { nama: 'Gunungguruh', baseline_2024: 4588, pct: '15,7%', rank: 3, target_2029: 8538, gap: 3950 },
      { nama: 'Sukalarang', baseline_2024: 3354, pct: '15,7%', rank: 3, target_2029: 5854, gap: 2500 },
      { nama: 'Sukabumi', baseline_2024: 3877, pct: '13,9%', rank: 2, target_2029: 7227, gap: 3350 },
    ]
  },
  {
    dapil: 'Dapil 5',
    nama: 'Dapil 5',
    kecamatan_count: 9,
    desa_count: 69,
    rw_count: 518,
    dpt_2024: 279435,
    baseline_2024: 23377,
    target_suara_2029: 34777,
    target_kursi_2029: 1,
    gap_suara: 11400,
    kategori: 'Perjuangan',
    is_tambah: false,
    ambang_tambahan: null,
    target_desa_avg: 496.8,
    target_rw_avg: 72.8,
    gap_rw_avg: 23.8,
    strategi: 'Pertahankan 1 kursi aman. Perkuat mesin teritorial di Sagaranten, Purabaya, Curugkembar, dan Jampangtengah.',
    kecamatan: [
      { nama: 'Lengkong', baseline_2024: 2736, pct: '17,8%', rank: 2, target_2029: 3436, gap: 700 },
      { nama: 'Sagaranten', baseline_2024: 4651, pct: '16,7%', rank: 2, target_2029: 6851, gap: 2200 },
      { nama: 'Purabaya', baseline_2024: 3460, pct: '14,8%', rank: 2, target_2029: 4760, gap: 1300 },
      { nama: 'Curugkembar', baseline_2024: 2133, pct: '13,1%', rank: 2, target_2029: 3533, gap: 1400 },
      { nama: 'Cidadap', baseline_2024: 1256, pct: '11,8%', rank: 4, target_2029: 1956, gap: 700 },
      { nama: 'Nyalindung', baseline_2024: 3007, pct: '10,7%', rank: 4, target_2029: 4407, gap: 1400 },
      { nama: 'Jampangtengah', baseline_2024: 3694, pct: '9,7%', rank: 4, target_2029: 5794, gap: 2100 },
      { nama: 'Cidolog', baseline_2024: 884, pct: '8,4%', rank: 5, target_2029: 1484, gap: 600 },
      { nama: 'Pabuaran', baseline_2024: 1556, pct: '6,7%', rank: 6, target_2029: 2556, gap: 1000 },
    ]
  },
  {
    dapil: 'Dapil 6',
    nama: 'Dapil 6',
    kecamatan_count: 9,
    desa_count: 73,
    rw_count: 559,
    dpt_2024: 295848,
    baseline_2024: 16114,
    target_suara_2029: 22414,
    target_kursi_2029: 1,
    gap_suara: 6300,
    kategori: 'Perjuangan',
    is_tambah: false,
    ambang_tambahan: null,
    target_desa_avg: 307.0,
    target_rw_avg: 44.0,
    gap_rw_avg: 12.4,
    strategi: 'Amankan 1 kursi definitif. Konsolidasi intensif basis Surade, Ciracap, dan Jampangkulon serta optimalkan simpul RW pesisir selatan.',
    kecamatan: [
      { nama: 'Surade', baseline_2024: 6628, pct: '15,5%', rank: 1, target_2029: 7528, gap: 900 },
      { nama: 'Jampangkulon', baseline_2024: 2012, pct: '8,2%', rank: 7, target_2029: 3112, gap: 1100 },
      { nama: 'Ciracap', baseline_2024: 2082, pct: '7,1%', rank: 7, target_2029: 3082, gap: 1000 },
      { nama: 'Cibitung', baseline_2024: 981, pct: '6,6%', rank: 7, target_2029: 1181, gap: 200 },
      { nama: 'Tegalbuleud', baseline_2024: 1130, pct: '5,9%', rank: 7, target_2029: 1530, gap: 400 },
      { nama: 'Cimanggu', baseline_2024: 700, pct: '5,7%', rank: 7, target_2029: 1200, gap: 500 },
      { nama: 'Kalibunder', baseline_2024: 868, pct: '5,6%', rank: 5, target_2029: 1568, gap: 700 },
      { nama: 'Waluran', baseline_2024: 715, pct: '4,5%', rank: 6, target_2029: 1315, gap: 600 },
      { nama: 'Ciemas', baseline_2024: 998, pct: '3,5%', rank: 8, target_2029: 1898, gap: 900 },
    ]
  }
];

export const TOTAL_KABUPATEN = {
  kecamatan_count: 47,
  desa_count: 386,
  rw_count: 3228,
  rt_count: 12917,
  dpt_2024: 1997822,
  baseline_2024: 161304,
  target_suara_2029: 256204,
  target_kursi_2029: 9,
  gap_suara: 94900,
};

